import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import './sentry'
// FixMe: 修复样式问题
import 'antd/dist/antd.min.css';

import './theme/index.less';

const root = createRoot(document.getElementById('root') as HTMLElement);

if (window.__POWERED_BY_WUJIE__) {
  const mount = () => {
    root.render(<App />);
  };

  const unmount = () => {
    root.unmount();
  };

  // 通过 props 转传入的 wujieMode 来判断是否需要改造生命周期
  if (window.$wujie?.props?.wujieMode === "rebuild") {
    mount();
  } else {
    window.__WUJIE_MOUNT = mount;
    window.__WUJIE_UNMOUNT = unmount;
  }
} else {
	root.render(<App />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
